import { FC } from 'react';

import { AppModalProps } from '@/types/modal.type';
import { ModalView } from '@/Components/ModalView';
import { CloseSvg } from '@/Components/Icons/CloseSvg';
import { Button } from '@/Components/Button';
import { FlickAnimation } from '@/Components/FlickAnimation';
import { FruitLemonSvg } from '@/Components/Icons/FruitLemonSvg';

export type MaxFlowsPublishedModalProps = AppModalProps<{}>;

export const MaxFlowsPublishedModal: FC<MaxFlowsPublishedModalProps> = ({
    onClose,
}) => {
    return (
        <ModalView
            maxWidth="sm"
            onClose={onClose}
            contentContainerClassName="py-4 text-brand-ocean flex flex-col justify-center items-center">
            <div className="flex flex-row items-center w-full px-6">
                <div className="flex-1 text-heading-four !font-bold text-brand-ocean text-left">
                    You’ve reached maximum Active Flows
                </div>
                <button
                    title="Close"
                    aria-label="Close"
                    className="p-2 -mr-1 transition-all rounded-md hover:cursor-pointer hover:bg-neutral-mid"
                    onClick={onClose}>
                    <CloseSvg className="[&_path]:stroke-1 [&_path]:stroke-brand-ocean" />
                </button>
            </div>
            <div className="mt-2 mb-4 relative flex flex-row items-center justify-center w-full gap-x-2">
                <FlickAnimation className="mr-12 z-10" />
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ">
                    <FruitLemonSvg      
                        width={54}
                        height={54}
                        className="ml-10 mt-2"
                    />
                </div>
            </div>
            <div className="flex flex-col mt-2 mx-6">
                <div className="text-body-text-15 text-brand-ocean">
                    It’s great to see you creating so many Flows! 
                </div>
                <div className="text-body-text-15 mt-3 text-brand-ocean">
                    You have just reached your plan limit for number of active, published Flows, so you won’t be able to publish this one without unpublishing another Flow first.
                </div>
                <div className="mt-6 flex flex-col gap-y-2">
                    <>
                        <Button
                            variant="primary"
                            className="w-full h-9 flex flex-row items-center justify-center gap-x-1"
                            elementType="a"
                            href={route('settings.organization.plan-billing-payments')}>
                            Upgrade to publish this Flow
                        </Button>
                        <Button
                            variant="default"
                            className="w-full h-9 flex flex-row items-center justify-center gap-x-1 relative"
                            elementType="a"
                            href={route('flows.index')}   
                        > Review & unpublish existing Flows
                        </Button>
                        <Button
                            variant="default"
                            className="w-full h-9 flex flex-row items-center justify-center gap-x-1 relative"
                            elementType="a"
                            href={route('settings.organization.usage')}   
                        > Review your usage
                        </Button>
                    </>
                </div>
            </div>
        </ModalView>
    );
};
